import React from 'react';
import { marketingUrl, salesUrl } from '@Constants/CommonConstants';

import './LoginAnonymousForm.scss';

function LoginAnonymousForm() {
  return (
    <div className="login-anonymous-form">
      {/* eslint-disable-next-line react/no-unescaped-entities */}
      <div className="login-anonymous-form__access">Don't have access yet?</div>
      <div className="login-anonymous-form__learn">
        <a href={marketingUrl} target="_blank" tabIndex="0" className="els-btn els-btn-link els-btn-sm e2e-learn-more" rel="noreferrer">
          <span>Learn more</span>
          <svg className="els-btn-icon">
            <use xlinkHref="#icon-chevron-right" />
          </svg>
        </a>
      </div>
      <div className="login-anonymous-form__contact-sales">
        <a href={salesUrl} target="_blank" tabIndex="0" className="els-btn els-btn-link els-btn-sm e2e-contact-sales" rel="noreferrer">
          <span>Contact sales</span>
          <svg className="els-btn-icon">
            <use xlinkHref="#icon-chevron-right" />
          </svg>
        </a>
      </div>
    </div>
  );
}

LoginAnonymousForm.propTypes = {};

export default LoginAnonymousForm;
